'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpecificityPlugin = getSpecificityPlugin;
/**
 * Returns a glamor plugin function that uses a given id
 * @param {String} id - An id used to prefix selectors
 * @return {Function} - A glamor plugin function
 */
function getSpecificityPlugin() {
  /**
   * This prefixes glamor-generated CSS selectors with an id
   * to prevent global styles from overriding glamor styles.
   * 
   * Learn more about glamor plugins:
   * https://github.com/threepointone/glamor/blob/master/docs/plugins.md
   */
  document.body.id = document.body.id || 'random-glamor-id-' + Math.random().toString().slice(2);
  return function specificityPlugin(_ref) {
    var selector = _ref.selector,
      style = _ref.style;
    var splitSelector = selector.split(',');
    if (~splitSelector[0].indexOf('#' + document.body.id)) {
      return {
        selector: selector,
        style: style
      };
    }
    var prefixedSelector = splitSelector.map(function (sel) {
      return '#' + document.body.id + ' ' + sel.trim();
    }).join(', ');
    return {
      selector: prefixedSelector,
      style: style
    };
  };
}